export const DEFAULT_TTL = 2 * 60 * 60 * 1000;

export const ORDERS_STORAGE_KEY = 'cat_orders';

export const ORDER_SESSION_KEY = 'cat_order';

export const MEAL_ORDER_STORAGE_KEY = 'order';

export const SAVE_TO_STATE_KEY = 'saveToState';

export const ORDER_REQUEST_KEY = 'orderRequest';

export const GLOBAL_DATA = 'data';
